import { buildinfo, cwdDir, getBuildinfoVite } from "@/share"
import { IAnyBuildConfigByVite } from "@/share/type"
import { error } from "@/util"
import path from "node:path";
import fs from "fs-extra";
import packageJson, { VersionNotFoundError } from 'package-json';

export interface IAllNeedModule<T = object> {
    // @ts-ignore
    vite: object extends T ? typeof import("vite") : string
    // @ts-ignore
    vue: object extends T ? typeof import("vue") : string
    // @ts-ignore
    vueRouter: object extends T ? typeof import("vue-router") : string
    // @ts-ignore
    sass: object extends T ? typeof import("sass") : string
    // @ts-ignore
    viteVue: object extends T ? typeof import("@vitejs/plugin-vue") : string
    // @ts-ignore
    viteVueJsx: object extends T ? typeof import("@vitejs/plugin-vue-jsx") : string
    // @ts-ignore
    viteMd: object extends T ? typeof import("vite-plugin-md") : string
    // @ts-ignore
    dts: object extends T ? typeof import("vite-plugin-dts") : string
    // @ts-ignore
    vitePluginWindicss: object extends T ? typeof import("vite-plugin-windicss") : string
    // @ts-ignore
    windicss: object extends T ? typeof import("windicss") : string
    // @ts-ignore
    hljs: object extends T ? typeof import("highlight.js") : string
    // @ts-ignore
    markdownIt: object extends T ? typeof import("markdown-it") : string
    // @ts-ignore
    markdownItAnchor: object extends T ? typeof import("markdown-it-anchor") : string
    // @ts-ignore
    transliteration: object extends T ? typeof import("transliteration") : string
}

const allNeedModule: IAllNeedModule<string> = {
    vite: "vite||^4.0.0", // 需要vite@4.0.0版本以上
    vue: "vue||^3.0.0", // 需要vue3
    vueRouter: "vue-router||^4",
    sass: "sass||^1.59.0",
    viteVue: "@vitejs/plugin-vue||^4.0.0",
    viteVueJsx: "@vitejs/plugin-vue-jsx||^3.0.0",
    viteMd: "vite-plugin-md||^0.21.0",
    dts: "vite-plugin-dts||^2.1.0",
    vitePluginWindicss: "vite-plugin-windicss||^1.8.0",
    windicss: "windicss||^3.5.0",
    hljs: "highlight.js||^11.7.0",
    markdownIt: "markdown-it||^13.0.0",
    markdownItAnchor: "markdown-it-anchor||^8.6.7",
    transliteration: "transliteration||^2.3.5",
}

export const allModules: IAllNeedModule = {
    vite: undefined,
    vue: undefined,
    vueRouter: undefined,
    sass: undefined,
    viteVue: undefined,
    viteVueJsx: undefined,
    viteMd: undefined,
    dts: undefined,
    vitePluginWindicss: undefined,
    windicss: undefined,
    hljs: undefined,
    markdownIt: undefined,
    markdownItAnchor: undefined,
    transliteration: undefined,
}

export async function loadModule() {
    const keys = Object.keys(allNeedModule)
    let isFailed = []
    let notMatched = []
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const m = allNeedModule[key].split("||")
        const name = m[0]
        try {
            const version = m[1]
            if (version) {
                await packageJson(name, { version: version }) // 能获取到对应的版本即可
                allModules[key] = await import(m[0])
            } else {
                allModules[key] = await import(m[0])
            }
        } catch (error) {
            if (error instanceof VersionNotFoundError) {
                notMatched.push(allNeedModule[key])
            } else {
                isFailed.push(allNeedModule[key])
            }
        }
    }

    const res = !!isFailed.length ? isFailed : allModules
    if (Array.isArray(res)) {
        error(`未安装包：${res.join(" ")}`, "exit")
        return
    }
    if (notMatched.length) {
        error(`包版本未匹配：${notMatched.join(" ")}`, "exit")
        return
    }
    await getAnybuildConfigAsync()
}

export const holder: {
    userConfig: {
        path: string
        config: IAnyBuildConfigByVite
        dependencies: string[]
    }
} = {
    userConfig: undefined
}

export function getAnybuildConfig() {
    if (holder.userConfig) return holder.userConfig
}

export async function getAnybuildConfigAsync() {
    if (!allModules.vite) return
    if (fs.pathExistsSync(path.resolve(cwdDir, "anybuild.config.ts"))) {
        let _config = getBuildinfoVite()
        const isDev = !!_config.watch
        const { vite: { loadConfigFromFile } } = allModules

        holder.userConfig = await loadConfigFromFile(
            {
                mode: isDev ? "development" : "production",
                command: isDev ? 'serve' : 'build'
            },
            "anybuild.config.ts",
            cwdDir
        ) as any
    } else {
        holder.userConfig = {
            path: path.resolve(cwdDir, "anybuild.config.ts"),
            config: {
                alias: {
                    "@": "./src"
                },
                define: {
                    "__MD_MATCH__": "'@root/src/components/*/index.*.md'",
                    "__DEMO_MATCH__": "'@root/src/components/*/demo/*.vue'",
                    "__COMP_MATCH__": "'@root/src/components/*/index.ts'",
                    "__DOCS_MATCH__": "'@root/docs/*/*.md'",
                }
            },
            dependencies: []
        }
    }
    return holder.userConfig
}